import { type CSSProperties } from 'react';
import { useAutoDownloadRecovery } from './useAutoDownloadRecovery';

/**
 * Host for the automatic stuck-download recovery (see useAutoDownloadRecovery).
 * Renders only a brief non-blocking toast just before the silent force-resync
 * reload; all logic lives in the hook. Mount once inside SyncGate (ready phase).
 */

const toastStyle: CSSProperties = {
  position: 'fixed',
  left: '50%',
  bottom: 'var(--sp-6, 24px)',
  transform: 'translateX(-50%)',
  zIndex: 1002,
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--sp-2, 8px)',
  padding: '10px 16px',
  borderRadius: 'var(--radius-md, 10px)',
  background: 'var(--bg-inverse, #0f172a)',
  color: 'var(--text-inverse, #f8fafc)',
  fontSize: 'var(--font-size-sm, 14px)',
  fontWeight: 'var(--font-weight-medium, 500)',
  boxShadow: '0 10px 30px rgba(15, 23, 42, 0.35)',
  pointerEvents: 'none',
};

export function AutoDownloadRecovery(): React.ReactElement | null {
  const { toastVisible } = useAutoDownloadRecovery();
  if (!toastVisible) return null;
  return (
    <div style={toastStyle} role="status" aria-live="polite">
      <span aria-hidden>⟳</span>
      <span>Restoring synchronization…</span>
    </div>
  );
}
